import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/home/Hero";
import ServicesOverview from "@/components/home/ServicesOverview";
import WhoWeServe from "@/components/home/WhoWeServe";
import WhyChoose from "@/components/home/WhyChoose";
import HowItWorks from "@/components/home/HowItWorks";

import Testimonials from "@/components/home/Testimonials";
import FAQPreview from "@/components/home/FAQPreview";
import CTABanner from "@/components/home/CTABanner";

import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Non-Emergency Medical Transportation, Medical Transportation Services & Wheelchair Transportation Service | Portland</title>
        <meta name="description" content="Safe non-emergency medical & wheelchair transportation in Portland, OR. Rides to dialysis, hospitals & appointments. Call 971-344-5446." />
        <meta name="keywords" content="non emergency medical transportation Portland, wheelchair transportation Portland, NEMT Portland Oregon" />
        <link rel="canonical" href="https://anemt.org/" />
        <meta property="og:title" content="ANEMT — Medical Transportation in Portland, OR" />
        <meta property="og:description" content="Reliable wheelchair & ambulatory medical transportation. Private-pay only. Call 971-344-5446." />
        <meta property="og:url" content="https://anemt.org/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://anemt.org/og-image.png" />
      </Helmet>
      <Header />
      <main className="flex-1">
        <Hero />
        <ServicesOverview />
        <WhoWeServe />
        <WhyChoose />
        <HowItWorks />

        
        <Testimonials />
        <FAQPreview />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
